import { useEffect, useState } from 'react';
import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';

export const useLogViewFavoriteRecommendedMarketModal = (
  marketId: number,
  count: number,
) => {
  const [isLogged, setIsLogged] = useState(false);
  const logMarketAnalytics = useLogMarketAnalyticsEvent(marketId);

  useEffect(() => {
    if (isLogged) return;

    const result = logMarketAnalytics({
      name: 'VIEW_FAVORITE_RECOMMENDED_MARKET_MODAL',
      analytics: {
        RECOMMENDED_MARKET_COUNT: count,
      },
    });
    setIsLogged(result);
  }, [count, isLogged, logMarketAnalytics]);
};
